<span class="chip-inner">
	<ng-content></ng-content>
</span>
